module.exports = __webpack_public_path__ + "img/docbanner2.b812b8fb.png";